import React, { useState } from 'react';
import cn from 'classnames';
import { ReactComponent as HistoryIcon } from '../../../resource/HistoryColoredIcon.svg';
import { ReactComponent as GeoTagIcon } from '../../../resource/GeoTagIcon.svg';
import ChangingHistory from '../../ChangingHistory/ChangingHistory';
import RequestMap from '../../request-map';
import { requestsActions } from '../../../containers/Requests/requests.actions';
import styles from './RequestHistoryAndMap.module.scss';
import { Tooltip } from 'antd';

const RequestHistoryAndMap = ({
  request = {},
  rootClassName,
  iconClassName,
}) => {
  const [historyModalOpen, setHistoryModalOpen] = useState(false);

  const [mapOpen, setMapOpen] = useState(false);

  const toggleHistoryModal = (e) => {
    if (e) {
      e.stopPropagation();
    }

    setHistoryModalOpen((prev) => !prev);
  };

  const toggleMap = (e) => {
    if (e) {
      e.stopPropagation();
    }

    setMapOpen((prev) => !prev);
  };

  return (
    <div className={cn(styles.root, rootClassName)}>
      <Tooltip title="История">
        <HistoryIcon
          style={{ cursor: 'pointer' }}
          className={iconClassName}
          onClick={toggleHistoryModal}
        />
      </Tooltip>
      <ChangingHistory
        hide={toggleHistoryModal}
        visible={historyModalOpen}
        request={request.id}
        getHistory={requestsActions.getHistory}
      />
      <Tooltip title="Карта">
        <GeoTagIcon
          style={{ cursor: 'pointer' }}
          className={iconClassName}
          onClick={toggleMap}
        />
      </Tooltip>
      {mapOpen && (
        <RequestMap
          visible={mapOpen}
          onHide={toggleMap}
          mapRequests={[request]}
          requests={[request]}
        />
      )}
    </div>
  );
};

export default RequestHistoryAndMap;
